export default __webpack_public_path__ + "static/media/028-tools-and-utensils-1.1ccbe079.png";